import angular from 'angular';

/**
 * @memberOf cms.input.align
 * @property {object}      bindings.errors     Form errors object
 * @property {object|text} bindings.model      Input value reference
 * @property {string}      bindings.title      Input title and/or placeholder
 * @property {string}      bindings.labelSize  Label column size (1-12)
 * @property {string}      bindings.inputSize  Input column size (1-12)
 * @property {string}      bindings.aclShow    ACL config - show input
 * @property {string}      bindings.aclDisable ACL config - disable input
 *
 */
let cmsInputAlign = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        labelSize: '@',
        inputSize: '@',
        aclShow: '<?',
        aclDisable: '<?'
    },
    template: require('./align.html')
};

export default angular.module('cms.input.align', []).component('cmsInputAlign', cmsInputAlign).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Controls/AlignControl/CmsInputAlign.js